import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, errMsg } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem("cached_user", JSON.stringify(data));
      setUser(data);
    } catch (e) {
      // Hors-ligne : conserver la dernière session connue au lieu d'éjecter vers /login
      if (!navigator.onLine) {
        const cached = localStorage.getItem("cached_user");
        if (cached) {
          try { setUser(JSON.parse(cached)); return; } catch (parseErr) { console.warn("cached_user illisible", parseErr); }
        }
      }
      setUser(null);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: retour OAuth — AuthCallback échange le session_id avant tout appel /auth/me
    if (window.location.hash?.includes("session_id=")) return;
    load();
  }, [load]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      // Le token JWT vit uniquement dans un cookie httpOnly posé par le serveur
      localStorage.setItem("cached_user", JSON.stringify(data.user));
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: errMsg(e) };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("Déconnexion serveur impossible (hors-ligne ?)", e); }
    localStorage.removeItem("cached_user");
    setUser(null);
  };

  const hasPerm = useCallback((perm) => {
    if (!user) return false;
    const perms = user.permissions || [];
    return perms.includes("*") || perms.includes(perm);
  }, [user]);

  return <AuthCtx.Provider value={{ user, setUser, login, logout, hasPerm, reload: load }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
